module.exports = __webpack_public_path__ + "c000872a.svg";